import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiRoot, EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class TtHttpClientService {
  readonly baseUrl: string;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly envService: EnvService
  ) {
    this.baseUrl = envService.getWebAPIRoot(ApiRoot.Core);
  }

  post<T>(url: string, params: HttpParams, isUrlAnAbsolutePath = false) {
    const paramsObject = params.keys().reduce((object: any, key) => {
      object[key] = params.get(key);
      return object;
    }, {});

    return this.httpClient.post<T>((isUrlAnAbsolutePath ? '' : this.baseUrl) + url, paramsObject).pipe(
      catchError((err: HttpErrorResponse) => {
        throw this.onError(err);
      })
    );
  }

  postCustomObject<T>(url: string, params: any, isUrlAnAbsolutePath = false) {
    return this.httpClient.post<T>((isUrlAnAbsolutePath ? '' : this.baseUrl) + url, params).pipe(
      catchError((err: HttpErrorResponse) => {
        throw this.onError(err);
      })
    );
  }

  put<T>(url: string, item: T, params?: HttpParams, isUrlAnAbsolutePath = false) {
    return this.httpClient.put<T>((isUrlAnAbsolutePath ? '' : this.baseUrl) + url, item, { params }).pipe(
      catchError((err: HttpErrorResponse) => {
        throw this.onError(err);
      })
    );
  }

  // notice the <T>, making the method generic
  get<T>(url: string, responseType: any = 'json', params?: HttpParams, isUrlAnAbsolutePath = false): Observable<T> {
    return this.httpClient
      .get<T>((isUrlAnAbsolutePath ? '' : this.baseUrl) + url, {
        params,
        responseType: responseType,
      })
      .pipe(
        catchError((err: any) => {
          throw this.onError(err);
        })
      );
  }

  onError(err: HttpErrorResponse) {
    if (this.envService.isProduction) return err;
    if (err.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
    }

    // ...optionally return a default fallback value so app can continue (pick one)
    // which could be a default value
    // return Observable.of<any>({my: "default value..."});
    // or simply an empty observable
    return err;
  }
}
